import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// ID class for this module
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.views.QuoteItemView.';
  public static readonly discardChanges = `${Id.prefix}discardChanges`;
  public static readonly quoteItemModalEditorNotImplemented = `${Id.prefix}quoteItemModalEditorNotImplemented`;
}

// Lang wrapper for this module
export class LangQuoteItemView {
  private constructor() {}
  public static discardChanges(): string {
    return interpolate(Id.discardChanges);
  }
  public static quoteItemModalEditorNotImplemented(): string {
    return interpolate(Id.quoteItemModalEditorNotImplemented);
  }
}

// Registration module
export class QuoteItemViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // Dialog Buttons
    register.add(Id.discardChanges, 'Discard Changes', 'Button label for discarding changes in quote item view');
    // Modal Editor Not Implemented
    register.add(
      Id.quoteItemModalEditorNotImplemented,
      'Quote Item Modal Editor is not implemented yet',
      'Error message for unimplemented quote item modal editor'
    );
  }
}
